'use strict';

/**
 * Validates whether the provided value is a valid email address.
 *
 * @param {string} value - The string to validate as an email address.
 * @returns {boolean} True if the value is a valid email address, false otherwise.
 */
function isEmail(value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
}

/**
 * Validates the newsletter subscription form by checking the email format and terms acceptance.
 *
 * @param {jQuery} form - The jQuery object representing the newsletter form.
 * @returns {boolean} Returns true if the form is valid, otherwise false.
 */
function validateNewsletterForm(form) {
    if (!form || !form.length) {
        return false;
    }

    const emailInput = form.find('.subscription-email');
    const email = emailInput.val();
    const termsCheckbox = form.find('#terms-conditions');
    const emailErrorMessage = form.find('.form-text');
    const termsErrorMessage = form.find('.terms-conditions .notification.with-tooltip');

    let isValid = true;
    if (!isEmail(email)) {
        emailInput.closest('.form-group').addClass('error');
        emailErrorMessage.text(emailErrorMessage.attr('aria-error'));
        isValid = false;
    } else {
        emailInput.closest('.form-group').removeClass('error');
        emailErrorMessage.empty();
    }

    if (!termsCheckbox.length || !termsCheckbox.is(':checked')) {
        termsErrorMessage.addClass('checkbox-error-message');
        isValid = false;
    } else {
        termsErrorMessage.removeClass('checkbox-error-message');
    }
    return isValid;
}

function handleSubscribeEmailClick(e) {
    e.preventDefault();
    const $this = $(this);
    const form = $this.closest('.subscribe-form');
    const url = $this.data('href');
    const emailInput = form.find('.subscription-email');
    const emailId = emailInput.val();

    if (validateNewsletterForm(form)) {
        $.spinner().start();
        $this.attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId
            },
            success: function () {
                const emailSuccess = form.find('.success-email-subscription');
                emailSuccess.addClass('d-flex');
                $.spinner().stop();
                setTimeout(() => {
                    emailSuccess.fadeOut(() => {
                        $this.attr('disabled', false);
                        form.find('#terms-conditions').prop('checked', false);
                        emailSuccess.removeClass('d-flex');
                        emailInput.val('');
                    });
                }, 3000);
            },
            error: function (err) {
                displayMessage(err, button);
                $.spinner().stop();
            }
        });
    }
}

function initSubscribeEmailListener () {
    $('.subscribe-email').on('click', handleSubscribeEmailClick);
}

module.exports = {
    initSubscribeEmailListener
}